webpackJsonp([142,3,112],{

/***/ 2348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientSignupForm_vue__ = __webpack_require__(2783);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7820e2fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientSignupForm_vue__ = __webpack_require__(2963);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2961)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7820e2fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientSignupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7820e2fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientSignupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/forms/PatientSignupForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7820e2fe", Component.options)
  } else {
    hotAPI.reload("data-v-7820e2fe", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMultiSelect_vue__ = __webpack_require__(2562);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6add7f54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMultiSelect_vue__ = __webpack_require__(2644);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2642)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6add7f54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseMultiSelect.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6add7f54", Component.options)
  } else {
    hotAPI.reload("data-v-6add7f54", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButtonGender_vue__ = __webpack_require__(2526);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c72e00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButtonGender_vue__ = __webpack_require__(2574);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2572)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioButtonGender_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c72e00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioButtonGender_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/RadioButtonGender.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98c72e00", Component.options)
  } else {
    hotAPI.reload("data-v-98c72e00", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export createApp */
/* unused harmony export createRef */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Plugin; });
/* unused harmony export defineAsyncComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defineComponent; });
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createElement; });
/* unused harmony export inject */
/* unused harmony export isRaw */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export markRaw */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onMounted; });
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ref; });
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCSSModule */
/* unused harmony export useCssModule */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export warn */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destroy on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(25);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

var SKIPFLAG = '__v_skip';
function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return val;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (!isForceTrigger() && val === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob[SKIPFLAG] = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_a = observed === null || observed === void 0 ? void 0 : observed.__ob__) === null || _a === void 0 ? void 0 : _a.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue)
            ? defaultValue()
            : defaultValue;
    }
    else if ((false)) {
        warn("Injection \"".concat(String(key), "\" not found."), vm);
    }
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var provide = {};
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        provide: function (key, value) {
            provide[key] = value;
            return this;
        },
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign(__assign({ propsData: rootProps }, rootComponent), { provide: __assign(__assign({}, provide), rootComponent.provide) }));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (this === null || this === void 0 ? void 0 : this.proxy) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode) {
            if (vnode.context)
                updateTemplateRef(vnode.context);
            if (vnode.children) {
                for (var i = 0; i < vnode.children.length; ++i) {
                    stack.push(vnode.children[i]);
                }
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.7.1";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),

/***/ 2526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_genders__ = __webpack_require__(1253);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'base-radio-group': function baseRadioGroup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1249));
    }
  },
  props: {
    value: [String, Object, Boolean],
    options: {
      type: Array,
      required: false,
      default: function _default() {
        return [{ value: __WEBPACK_IMPORTED_MODULE_0__constants_genders__["b" /* MALE */], text: this.$t('genderMale') }, { value: __WEBPACK_IMPORTED_MODULE_0__constants_genders__["a" /* FEMALE */], text: this.$t('genderFemale') }];
      }
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      localValue: null
    };
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
    });
  }
});

/***/ }),

/***/ 2529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Recaptcha; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_demi__ = __webpack_require__(2563);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve() {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i]();
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var Recaptcha = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["a" /* defineComponent */])({
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": true
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  emits: ['render', 'verify', 'expired', 'error'],
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        emit = _ref.emit;
    var root = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["d" /* ref */])(null);
    var widgetId = Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["d" /* ref */])(null);

    var emitVerify = function emitVerify(response) {
      emit('verify', response);
    };

    var emitExpired = function emitExpired() {
      emit('expired');
    };

    var emitError = function emitError() {
      emit('error');
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["c" /* onMounted */])(function () {
      recaptcha.checkRecaptchaLoad();

      if (props.loadRecaptchaScript) {
        if (!document.getElementById(props.recaptchaScriptId)) {
          // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
          var script = document.createElement('script');
          script.id = props.recaptchaScriptId;
          script.src = "https://" + props.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + props.language;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
      }

      var opts = _extends({}, props, {
        callback: emitVerify,
        'expired-callback': emitExpired,
        'error-callback': emitError
      });

      var $root = root.value;
      var container = slots["default"] ? $root.children[0] : $root;
      recaptcha.render(container, opts, function (id) {
        widgetId.value = id;
        emit('render', id);
      });
    });
    return {
      root: root,
      widgetId: widgetId,
      reset: function reset() {
        recaptcha.reset(widgetId.value);
      },
      execute: function execute() {
        recaptcha.execute(widgetId.value);
      }
    };
  },
  render: function render() {
    var defaultSlot = this.$slots["default"];
    var defaultContent;

    if (typeof defaultSlot === 'function') {
      defaultContent = defaultSlot();
    } else {
      defaultContent = defaultSlot;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["b" /* h */])('div', {
      ref: 'root'
    }, defaultContent);
  }
});




/***/ }),

/***/ 2541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return recaptcha; });
var recaptcha = '6LcaZigTAAAAAIjIAg4Sto4Oawn_mub5saiN7xfY';

/***/ }),

/***/ 2562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_vue_select__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_transitions__ = __webpack_require__(1265);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base-select',
  components: {
    SlideYUpTransition: __WEBPACK_IMPORTED_MODULE_2_vue2_transitions__["a" /* SlideYUpTransition */]
  },
  props: {
    value: Array,
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('base-select.select-option');
      }
    },
    options: Array,
    filtered: {
      type: Boolean,
      required: false,
      default: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    valueProp: {
      type: String,
      required: false,
      default: 'value'
    },
    loading: {
      type: Boolean,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      localValue: [],
      localOptions: []
    };
  },

  methods: {
    reduce: function reduce(item) {
      if (item) {
        return item[this.valueProp];
      } else {
        return null;
      }
    },
    mapOption: function mapOption(option) {
      if (!option) {
        return null;
      }
      var mappedOpt = {};
      mappedOpt[this.label] = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(option, this.label);
      mappedOpt[this.valueProp] = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(option, this.valueProp);
      return mappedOpt;
    }
  },
  computed: {
    isLoading: function isLoading() {
      return this.loading ? this.loading : !this.options || this.options.length === 0;
    }
  },
  created: function created() {
    var _this = this;

    this.uid = this._uid.toString();
    this.localValue = this.value;
    this.localOptions = this.options.map(function (item) {
      return _this.mapOption(item);
    });
    /* this.$watch('value', (value, old) => {
      if (!old || (value && old.value !== value.value)) {
        this.localValue = this.mapOption(value)
      }
    }) */
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
      _this.$emit('change', value);
    });
    this.$watch('value', function (value) {
      _this.localValue = value;
    });
    this.$watch('options', function (value) {
      _this.localOptions = value.map(function (item) {
        return _this.mapOption(item);
      });
    });
  }
});

/***/ }),

/***/ 2563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vue2 */
/* unused harmony export isVue2 */
/* unused harmony export isVue3 */
/* unused harmony export version */
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__ = __webpack_require__(2521);
/* unused harmony reexport EffectScope */
/* unused harmony reexport computed */
/* unused harmony reexport createApp */
/* unused harmony reexport createRef */
/* unused harmony reexport customRef */
/* unused harmony reexport defineAsyncComponent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["b"]; });
/* unused harmony reexport del */
/* unused harmony reexport effectScope */
/* unused harmony reexport getCurrentInstance */
/* unused harmony reexport getCurrentScope */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["c"]; });
/* unused harmony reexport inject */
/* unused harmony reexport isRaw */
/* unused harmony reexport isReactive */
/* unused harmony reexport isReadonly */
/* unused harmony reexport isRef */
/* unused harmony reexport markRaw */
/* unused harmony reexport nextTick */
/* unused harmony reexport onActivated */
/* unused harmony reexport onBeforeMount */
/* unused harmony reexport onBeforeUnmount */
/* unused harmony reexport onBeforeUpdate */
/* unused harmony reexport onDeactivated */
/* unused harmony reexport onErrorCaptured */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["d"]; });
/* unused harmony reexport onScopeDispose */
/* unused harmony reexport onServerPrefetch */
/* unused harmony reexport onUnmounted */
/* unused harmony reexport onUpdated */
/* unused harmony reexport provide */
/* unused harmony reexport proxyRefs */
/* unused harmony reexport reactive */
/* unused harmony reexport readonly */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["e"]; });
/* unused harmony reexport set */
/* unused harmony reexport shallowReactive */
/* unused harmony reexport shallowReadonly */
/* unused harmony reexport shallowRef */
/* unused harmony reexport toRaw */
/* unused harmony reexport toRef */
/* unused harmony reexport toRefs */
/* unused harmony reexport triggerRef */
/* unused harmony reexport unref */
/* unused harmony reexport useAttrs */
/* unused harmony reexport useCSSModule */
/* unused harmony reexport useCssModule */
/* unused harmony reexport useSlots */
/* unused harmony reexport warn */
/* unused harmony reexport watch */
/* unused harmony reexport watchEffect */
/* unused harmony reexport watchPostEffect */
/* unused harmony reexport watchSyncEffect */
/* unused harmony reexport Vue */



function install(_vue) {
  _vue = _vue || __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
  if (_vue && !_vue['__composition_api_installed__'])
    _vue.use(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["a" /* default */])
}

install(__WEBPACK_IMPORTED_MODULE_0_vue__["default"])

var isVue2 = true
var isVue3 = false
var Vue2 = __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
var version = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].version

/**VCA-EXPORTS**/

/**VCA-EXPORTS**/




/***/ }),

/***/ 2564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validationsMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);


var validationsMixin = {
	mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
	methods: {
		fieldIsValid: function fieldIsValid(prop) {
			/* eslint-disable no-unused-vars */
			var _$v$prop = this.$v[prop],
			    $dirty = _$v$prop.$dirty,
			    $error = _$v$prop.$error;

			return $dirty ? !$error : null;
		},
		validateState: function validateState(prop) {
			var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form';

			/* eslint-disable no-unused-vars */
			var _$v$formName$prop = this.$v[formName][prop],
			    $dirty = _$v$formName$prop.$dirty,
			    $error = _$v$formName$prop.$error;

			return this.$v[formName].$dirty && $dirty ? !$error : null;
		},
		fieldsAreValid: function fieldsAreValid() {
			if (this.$v.$invalid) {
				this.$v.$touch();
				return false;
			}
			return true;
		},
		formIsValid: function formIsValid() {
			var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'form';

			this.$v[formName].$touch();
			if (this.$v[formName].$invalid) {
				return false;
			}
			return true;
		},
		getAllErrors: function getAllErrors() {
			var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'form';

			this.$v[formName].$touch();
			if (this.$v[formName].$invalid) {
				return this.$v[formName].$error;
			}
			return null;
		}
	}
};

/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2989222c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-98c72e00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RadioButtonGender.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-98c72e00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RadioButtonGender.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2573:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-radio-group", {
    attrs: { options: _vm.options, state: _vm.state, errorMsg: _vm.errorMsg },
    model: {
      value: _vm.localValue,
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98c72e00", esExports)
  }
}

/***/ }),

/***/ 2590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(282);



var client = function client() {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getCode: function getCode(code) {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/codes/' + code));
  },
  showGroupDialog: function showGroupDialog(codeGroup) {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/group/' + codeGroup));
  },
  getSpecialties: function getSpecialties() {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/specialties'));
  },
  getSpecialtiesInfo: function getSpecialtiesInfo() {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/specialties/info'));
  },
  getConsultationTypes: function getConsultationTypes(specialty) {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/consultation-types'), { params: { specialtyId: specialty } });
  },
  getLanguages: function getLanguages(specialty) {
    return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/languages'), { params: { specialtyId: specialty } });
  },
  resetCode: function resetCode(code, reservationNumber, startDate, endDate) {
    return client().post(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/code-resets', {
      code: code,
      reservationNumber: reservationNumber,
      startDate: startDate,
      endDate: endDate
    }));
  }
});

/***/ }),

/***/ 2642:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2643);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("8e27ed06", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6add7f54\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseMultiSelect.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6add7f54\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseMultiSelect.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2643:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 2644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "slide-y-up-transition",
    [
      _c("v-select", {
        attrs: {
          multiple: "",
          placeholder: _vm.placeholder,
          options: _vm.localOptions,
          filtered: _vm.filtered,
          searchable: _vm.searchable,
          label: _vm.label,
          value: _vm.valueProp,
          closeOnSelect: _vm.closeOnSelect,
          loading: _vm.isLoading,
          disabled: _vm.disabled,
          reduce: _vm.reduce
        },
        scopedSlots: _vm._u([
          {
            key: "open-indicator",
            fn: function(ref) {
              var attributes = ref.attributes
              return [
                _c("span", _vm._b({}, "span", attributes, false), [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "12",
                        height: "6",
                        viewBox: "0 0 12 6"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_4_Copy",
                          "data-name": "Path 4 Copy",
                          d: "M0,0,6,6,0,12Z",
                          transform: "translate(12) rotate(90)",
                          fill: "#8a8a8a"
                        }
                      })
                    ]
                  )
                ])
              ]
            }
          },
          {
            key: "no-options",
            fn: function() {
              return [
                _vm._v(
                  "\r\n      " +
                    _vm._s(_vm.$t("base-select.noOptions")) +
                    "\r\n    "
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.localValue,
          callback: function($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6add7f54", esExports)
  }
}

/***/ }),

/***/ 2645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__ = __webpack_require__(182);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
        BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */]
    },
    props: {
        value: Date,
        minorsAllowed: {
            type: Boolean,
            required: false,
            default: false
        },
        showLabels: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function data() {
        return {
            day: null,
            month: null,
            year: null
        };
    },

    computed: {
        date: function date() {
            if (!this.dateIsCompleted) {
                return null;
            }
            return new Date(Date.UTC(this.year, this.month - 1, this.day));
        },
        dateIsCompleted: function dateIsCompleted() {
            return this.day && this.day.length > 0 && parseInt(this.day) > 0 && this.month && this.month.length > 0 && parseInt(this.month) > 0 && this.year && this.year.length === 4 && this.year > 1900 && this.year;
        },
        dateIsValid: function dateIsValid() {
            return this.date && this.date.getUTCMonth() === this.month - 1 && this.date.getUTCDate() === parseInt(this.day) && this.date.getUTCFullYear() === parseInt(this.year) && this.date.getFullYear() >= 1900 && Object(__WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["c" /* dateIsBeforeToday */])(this.date) && (this.minorsAllowed || this.dateIs18YearsOldOrMore);
        },
        dateIs18YearsOldOrMore: function dateIs18YearsOldOrMore() {
            if (!this.dateIsCompleted) {
                return true;
            }
            var today = new Date();
            var eighteenYearsAgo = new Date(today.getUTCFullYear() - 18, today.getUTCMonth(), today.getUTCDate());
            return this.date <= eighteenYearsAgo;
        },

        localValue: {
            get: function get() {
                return this.dateIsValid ? this.year + '-' + this.month + '-' + this.day : null;
            }
            /* set (newValue) {
                if (newValue && typeof newValue === 'string') {
                    // Split newValue date from xx-xx-xxxx to data
                    const date = newValue.split('-')
                    this.day = date[2]
                    this.month = date[1]
                    this.year = date[0]
                } else if (typeof newValue === 'object') {
                    this.day = newValue.getDate()
                    this.month = newValue.getMonth() + 1
                    this.year = newValue.getFullYear()
                }
            } */

        }
    },
    created: function created() {
        var _this = this;

        this.localValue = this.value;
        this.$watch('value', function (value) {
            _this.localValue = value;
        });
        this.$watch('localValue', function (value) {
            _this.$emit('input', _this.date);
            _this.$emit('change', _this.date);
        });
    }
});

/***/ }),

/***/ 2651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var api = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;

/* harmony default export */ __webpack_exports__["a"] = ({
  getLanguages: function getLanguages() {
    return api.get('/languages');
  },
  getProfLanguagesBySpecialty: function getProfLanguagesBySpecialty(specialtyId) {
    return api.get('/languages/GetProfLanguagesBySpecialty', { params: { specialtyId: specialtyId } });
  },
  getCenterLanguagesBySpecialty: function getCenterLanguagesBySpecialty(specialtyId) {
    return api.get('/languages/GetCenterLanguagesBySpecialty', { params: { specialtyId: specialtyId } });
  }
});

/***/ }),

/***/ 2714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BARCELO_LANDING_NAME */
/* unused harmony export NAUTALIA_LANDING_NAME */
/* unused harmony export CARREFOUR_LANDING_NAME */
/* unused harmony export MSM_LANDING_NAME */
/* unused harmony export IBEROSTAR_LANDING_NAME */
/* unused harmony export WAMOS_LANDING_NAME */
/* unused harmony export ASSEGUR_LANDING_NAME */
/* unused harmony export UNIHEALTH_LANDING_NAME */
/* harmony export (immutable) */ __webpack_exports__["a"] = GET_TRAVEL_COMPANIES;
/* unused harmony export isTravelCompany */
var BARCELO_LANDING_NAME = 'barcelo';
var NAUTALIA_LANDING_NAME = 'nautalia';
var CARREFOUR_LANDING_NAME = 'viajescarrefour';
var MSM_LANDING_NAME = 'msm';
var IBEROSTAR_LANDING_NAME = 'iberostar';
var WAMOS_LANDING_NAME = 'wamos';
var ASSEGUR_LANDING_NAME = 'assegur';
var UNIHEALTH_LANDING_NAME = 'unihealth';

function GET_TRAVEL_COMPANIES() {
    return [BARCELO_LANDING_NAME, NAUTALIA_LANDING_NAME, CARREFOUR_LANDING_NAME, IBEROSTAR_LANDING_NAME, WAMOS_LANDING_NAME, ASSEGUR_LANDING_NAME];
}

function isTravelCompany(company) {
    return GET_TRAVEL_COMPANIES().includes(company);
}

/***/ }),

/***/ 2715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBirthdateInput_vue__ = __webpack_require__(2645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a68d44a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBirthdateInput_vue__ = __webpack_require__(2718);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2716)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBirthdateInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a68d44a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBirthdateInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseBirthdateInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a68d44a8", Component.options)
  } else {
    hotAPI.reload("data-v-a68d44a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("228b04f0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a68d44a8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseBirthdateInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a68d44a8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseBirthdateInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "inline-input form-group" },
    [
      _c("b-col", { attrs: { sm: "12", md: "4" } }, [
        _c("span", { staticClass: "text-uppercase text-type-inline-input" }, [
          _vm._v(_vm._s(_vm.$t("signupOH.birthDate")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "pr-2" },
        [
          _c("b-form-input", {
            attrs: {
              type: "number",
              placeholder: "DD",
              label: _vm.showLabels ? _vm.$t("signupOH.dayBirth") : null,
              min: 1,
              max: 31
            },
            model: {
              value: _vm.day,
              callback: function($$v) {
                _vm.day = $$v
              },
              expression: "day"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "pr-2" },
        [
          _c("b-form-input", {
            attrs: {
              type: "number",
              placeholder: "MM",
              label: _vm.showLabels ? _vm.$t("signupOH.monthBirth") : null,
              min: 1,
              max: 12
            },
            model: {
              value: _vm.month,
              callback: function($$v) {
                _vm.month = $$v
              },
              expression: "month"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        [
          _c("b-form-input", {
            attrs: {
              type: "number",
              placeholder: "YYYY",
              label: _vm.showLabels ? _vm.$t("signupOH.yearBirth") : null,
              min: 1900,
              max: new Date().getUTCFullYear()
            },
            model: {
              value: _vm.year,
              callback: function($$v) {
                _vm.year = $$v
              },
              expression: "year"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.dateIsCompleted
        ? _c("b-form-invalid-feedback", { attrs: { state: _vm.dateIsValid } }, [
            _vm._v(_vm._s(_vm.$t("signupOH.invalidDate")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dateIsCompleted
        ? _c(
            "b-form-invalid-feedback",
            {
              attrs: { state: _vm.minorsAllowed || _vm.dateIs18YearsOldOrMore }
            },
            [_vm._v(_vm._s(_vm.$t("signupOH.errors.birthdateMore18")))]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a68d44a8", esExports)
  }
}

/***/ }),

/***/ 2783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseDatepicker__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseCheckbox__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_companiesLandingNames__ = __webpack_require__(2714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_forms_RadioButtonGender_vue__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_forms_BaseMultiSelect_vue__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_forms_BaseSelect_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_recaptcha__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_recaptcha__ = __webpack_require__(2529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__repositories_CompaniesRepository__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_base_forms_BaseBirthdateInput__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__repositories_GeographyRepository__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__repositories_LanguageRepository__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_validations_mixin__ = __webpack_require__(2564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__constants_db_companyCodeTypes__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_global_helpers__ = __webpack_require__(47);




var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























// Get subdomain from current url
var SUBDOMAIN = __WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* default */].getSubdomain();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'patient-sign-up-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_21__mixins_validations_mixin__["a" /* validationsMixin */]],
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["m" /* BForm */],
    BModal: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["_32" /* BModal */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["r" /* BFormGroup */],
    BButton: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["d" /* BButton */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["s" /* BFormInput */],
    BAlert: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* BAlert */],
    BContainer: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["k" /* BContainer */],
    'base-select': __WEBPACK_IMPORTED_MODULE_12__base_forms_BaseSelect_vue__["default"],
    'base-multiSelect': __WEBPACK_IMPORTED_MODULE_11__base_forms_BaseMultiSelect_vue__["default"],
    'radio-button-gender': __WEBPACK_IMPORTED_MODULE_10__base_forms_RadioButtonGender_vue__["default"],
    BaseCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_base_forms_BaseCheckbox__["default"],
    BaseDatepicker: __WEBPACK_IMPORTED_MODULE_4__components_base_forms_BaseDatepicker__["default"],
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_14_vue_recaptcha__["a" /* VueRecaptcha */],
    BaseBirthdateInput: __WEBPACK_IMPORTED_MODULE_16__components_base_forms_BaseBirthdateInput__["a" /* default */],
    BFormText: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["z" /* BFormText */]
  },
  props: {
    callback: {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      inOpenlegal: __WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["j" /* inOpenlegal */],
      inOpensalud360: __WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["k" /* inOpensalud360 */],
      siteKey: __WEBPACK_IMPORTED_MODULE_13__constants_recaptcha__["a" /* recaptcha */],
      visibleModalBusiness: false,
      visibleModalMessageInfo: false,
      dniregistered: false,
      form: {
        selectedCountry: {
          options: []
        },
        captcha: false,
        email: null,
        emailConfirmation: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        gender: null,
        countryId: null,
        stateId: null,
        prefixList: [],
        prefix: null,
        csrfToken: null,
        birthDate: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        },
        companyCode: null,
        nif: null,
        phoneNumber: null,
        prefixCountry: null,
        selectedLangs: null,
        reservationNumber: null,
        employeeGroup: null,
        reservationFromDate: null,
        reservationToDate: null,
        employeeNumber: null,
        employeeLocation: null,
        discoveryCheck: null,
        termsAccepted: false,
        privacyAccepted: false,
        formSelectLang: {
          options: []
        },
        selectDiscovery: {
          options: [{ value: '1', text: Object(__WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["j" /* inOpenlegal */])() ? this.$t('signupDiscovery.title1-openlegal') : this.$t('signupDiscovery.title1') }, { value: '2', text: Object(__WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["j" /* inOpenlegal */])() ? this.$t('signupDiscovery.title2-openlegal') : this.$t('signupDiscovery.title2') }, { value: '3', text: Object(__WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["j" /* inOpenlegal */])() ? this.$t('signupDiscovery.title3-openlegal') : this.$t('signupDiscovery.title3') }, { value: '4', text: this.$t('signupDiscovery.title4') }, { value: '5', text: this.$t('signupDiscovery.title5') }, { value: '6', text: 'Email' }, { value: '7', text: this.$t('signupDiscovery.title7') }, { value: '8', text: this.$t('signupDiscovery.title8') }, { value: '9', text: this.$t('signupDiscovery.title9') }, { value: '10', text: this.$t('signupDiscovery.title10') }, { value: '11', text: this.$t('signupDiscovery.title11') }]
        },
        selectProvince: {
          options: []
        },
        selectPrefix: {
          options: []
        }
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null,
      companyCodeIsValid: null,
      employeeNumberIsValid: null,
      codeInfo: {},
      userRegistered: false
    };
  },

  validations: {
    form: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        onlyText: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["d" /* onlyText */],
        validateName: function validateName() {
          return !!this.form.name && this.form.name !== '' && this.validateText(this.form.name);
        }
      },
      firstSurname: {
        onlyText: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["d" /* onlyText */],
        validateFirstSurname: function validateFirstSurname() {
          return this.form.firstSurname != null && this.form.firstSurname !== '' && this.validateText(this.form.firstSurname) || this.codeInfo && this.codeInfo.codeType === __WEBPACK_IMPORTED_MODULE_22__constants_db_companyCodeTypes__["a" /* EDUCATIVE_CENTER_CODE_TYPE */];
        }
      },
      secondSurname: {
        onlyText: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["d" /* onlyText */],
        validateSecondSurname: function validateSecondSurname() {
          return this.form.secondSurname === null || this.form.secondSurname === '' || this.validateText(this.form.secondSurname);
        }
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"],
        validateEmail: function validateEmail() {
          return !!this.form.email && this.form.email !== '';
        }
      },
      emailConfirmation: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"],
        sameAsEmail: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["sameAs"])('email'),
        validateEmailConfirmation: function validateEmailConfirmation() {
          return this.form.emailConfirmation != null && !!this.form.emailConfirmation;
        }
      },
      gender: {
        validateGender: function validateGender() {
          return this.form.gender != null || this.codeInfo && this.codeInfo.codeType === __WEBPACK_IMPORTED_MODULE_22__constants_db_companyCodeTypes__["a" /* EDUCATIVE_CENTER_CODE_TYPE */];
        }
      },
      countryId: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        validateCountry: function validateCountry() {
          return this.form.countryId != null && this.form.countryId !== '';
        }
      },
      stateId: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        validateState: function validateState() {
          return this.form.stateId != null && this.form.stateId !== '';
        }
      },
      birthDate: {
        validateBirthdate: function validateBirthdate() {
          return this.codeInfo.codeType === 2 || this.form.birthDate != null;
        }
      },
      discoveryCheck: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.in360;
        })
      },
      selectedLangs: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["minLength"])(1)
      },
      companyCode: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return this.in360;
        }),
        validateCompanyCode: function validateCompanyCode() {
          return !this.in360 || !!this.form.companyCode && (!this.employeeGroupFieldIsVisible || !!this.form.employeeGroup) && (!this.employeeGroupFreeFieldIsVisible || !!this.form.employeeLocation) && (!this.employeeNumberFieldIsVisible || !!this.form.employeeNumber);
        }
      },
      reservationNumber: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return _this2.in360 && !_this2.codeIsGeneric;
        })
      },
      employeeGroup: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return _this2.in360 && !_this2.employeeGroupFieldIsVisible;
        }),
        numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"]
      },
      employeeLocation: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return _this2.in360 && !_this2.employeeGroupFreeFieldIsVisible;
        })
      },
      reservationFromDate: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return _this2.in360 && !_this2.isTravelCompany;
        })
      },
      reservationToDate: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return _this2.in360 && !_this2.isTravelCompany;
        }),
        afterToday: function afterToday() {
          var _this3 = this;

          return Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
            return _this3.in360 && !_this3.isTravelCompany;
          }) ? __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["b" /* afterToday */] : true;
        },
        afterDate: function afterDate() {
          var _this4 = this;

          return Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
            return _this4.in360 && !_this4.isTravelCompany;
          }) ? Object(__WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["a" /* afterDate */])('reservationFromDate') : true;
        }
      },
      employeeNumber: {
        required: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["requiredIf"])(function () {
          return this.in360 && this.employeeNumberFieldIsVisible;
        })
      },
      nif: {
        validate: function validate() {
          return __WEBPACK_IMPORTED_MODULE_23__helpers_global_helpers__["l" /* inMx */] || this.form.nif != null || this.codeInfo.codeType === __WEBPACK_IMPORTED_MODULE_22__constants_db_companyCodeTypes__["a" /* EDUCATIVE_CENTER_CODE_TYPE */];
        },
        validateNIF: function validateNIF() {
          return this.$validators.validatePersonalId(this.form.nif, this.form.countryId, this.codeInfo.codeType);
        },
        validateNIFRegistered: function validateNIFRegistered() {
          return this.dniregistered !== true;
        }
      },
      prefixCountry: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        phone: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["g" /* phone */]
      },
      termsAccepted: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        onlyTrue: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["e" /* onlyTrue */]
      },
      captcha: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        onlyTrue: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["e" /* onlyTrue */]
      },
      privacyAccepted: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        onlyTrue: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["e" /* onlyTrue */]
      }
    }
  },
  methods: {
    builtInOkFnBusiness: function builtInOkFnBusiness() {
      this.visibleModalBusiness = false;
      window.location = this.$helpers.get360AppUrl();
    },
    builtInCancelFnBusiness: function builtInCancelFnBusiness() {
      this.form.companyCode = null;
      window.location.reload();
      this.visibleModalBusiness = false;
    },
    validateNIF: function validateNIF(dni) {
      return this.$validators.validatePersonalId(dni, this.form.countryId, this.codeInfo.codeType);
    },

    validateText: function validateText(text) {
      var re = /^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/i;
      if (!re.test(text)) {
        return false;
      } else {
        return true;
      }
    },
    builtInCancelBNP: function builtInCancelBNP() {
      this.visibleModalMessageInfo = false;
    },

    reCallProvince: function reCallProvince() {
      var _this5 = this;

      this.form.stateId = null;
      __WEBPACK_IMPORTED_MODULE_18__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(this.form.countryId).then(function (response) {
        _this5.form.selectProvince.options = response.data;
      });
    },
    handleError: function handleError() {
      this.form.captcha = false;
    },
    handleSuccess: function handleSuccess() {
      this.form.captcha = true;
    },
    signUpCheck: function signUpCheck() {
      if (this.form.companyCode != null && this.codeInfo.infoMessages && this.codeInfo.infoMessages.length > 0) {
        this.visibleModalMessageInfo = this.formIsValid();
      } else {
        this.signUp();
      }
    },
    signUp: function signUp() {
      var _this6 = this;

      var _this = this;
      this.$v.form.$touch();
      this.form.trySubmit = true;
      var maleRole = false;
      this.form.state.submitted = true;
      this.dniregistered = false;
      this.form.state.waiting = true;
      if (this.form.gender === 'H') maleRole = true;
      /* this.resetForm()
      this.form.state.submitted = true */
      if (this.formIsValid()) {
        var lng = [];
        this.form.selectedLangs.map(function (x, i) {
          lng.push(x.id);
        });
        this.$api.post('CreatePatient', {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || _this.$route.query.ReturnUrl || null),
          role: 'Paciente',
          codPromotion: this.form.companyCode != null ? this.form.companyCode.trim() : null,
          firstName: this.form.name.trim(),
          lastName1: this.codeInfo.codeType === 2 ? null : this.form.firstSurname.trim(),
          lastName2: this.codeInfo.codeType === 2 ? null : this.form.secondSurname != null ? this.form.secondSurname.trim() : null,
          male: this.codeInfo.codeType === 2 ? false : maleRole,
          female: this.codeInfo.codeType === 2 ? false : !maleRole,
          idHowToMeet: this.form.discoveryCheck != null ? this.form.discoveryCheck : 10,
          idCountry: this.form.countryId,
          idProvince: this.form.stateId,
          languages: lng,
          prefix: this.form.prefixCountry,
          phone: this.form.phoneNumber,
          dni: this.form.nif,
          email: this.form.email.toLowerCase(),
          bornDate: this.codeInfo.codeType === 2 ? null : this.form.birthDate,
          reservationNumber: this.form.reservationNumber,
          employeeGroup: this.form.employeeGroup,
          reservationFromDate: this.form.reservationFromDate,
          reservationToDate: this.form.reservationToDate,
          employeeNumber: this.form.employeeNumber,
          employeeLocation: this.form.employeeLocation
        }).then(function (response) {
          var res = response;
          if (!response.data) {
            res = response.response;
          }
          _this6.defaultLoginCallback(res);
        }).catch(function (error) {
          if (error) {
            _this6.form.state.errors = true;
            _this6.form.state.waiting = false;
            return _this6.$router.push({ path: '/cuenta/registro-correcto', query: { email: _this6.form.email.trim(), confirmSucessful: false } });
          }
        });
      } else {
        this.builtInCancelBNP();
        this.form.state.waiting = false;
      }
    },
    defaultLoginCallback: function defaultLoginCallback(response) {
      if (response.data) {
        switch (response.data.status) {
          case 200:
            if (response.data.data === 'business') {
              this.visibleModalBusiness = true;
            } else {
              return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } });
            }
            break;
          case 400:
            if (response.data.errorMessage === 'ApiUserCreationException: Company code is not valid.') {
              this.submitError = this.$t('error-checkextension');
            } else if (response.data.errorMessage === 'ApiUserCreationException: PatientCreationException: employee number registered') {
              this.employeeNumberIsValid = false;
              this.$set(this.form.state, 'waiting', false);
              this.submitError = this.$t('error-checkemployeenumber');
            } else {
              this.submitError = this.$t('error-alreadyregister');
            }
            this.form.state.unauthorized = true;
            this.form.state.waiting = false;
            break;
          case 403:
            this.submitError = response.data.message;
            this.form.state.unauthorized = true;
            this.form.state.waiting = false;
            break;
          case 502:
            if (response.data.data) {
              this.submitError = response.data.data;
            } else {
              this.submitError = this.$t('error-checkemployeenumber');
            }
            this.form.state.unauthorized = true;
            this.form.state.waiting = false;
            break;
          default:
            this.form.state.errors = true;
            this.form.state.waiting = false;
            break;
        }
      } else {
        this.form.state.errors = true;
        this.form.state.waiting = false;
      }
    },
    validateEmail: function validateEmail(email) {
      return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    ivecoAndExtensionEmailForEmployeeNumberInputDisplay: function ivecoAndExtensionEmailForEmployeeNumberInputDisplay() {
      if (this.codeInfo.isIveco) {
        if (this.form.email === '' || this.form.email === null || this.form.email === undefined || !this.validateEmail(this.form.email)) return false;
        var emailLowerCase = this.form.email.toLowerCase();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.codeInfo.emailExtensions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var extension = _step.value;

            if (emailLowerCase.includes(extension.toLowerCase())) {
              return false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return true;
      }
      return true;
    },
    checkCompanyCode: function checkCompanyCode() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var code;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                code = null;

                if (_this7.$v.form.companyCode.$model) {
                  _context.next = 4;
                  break;
                }

                _this7.companyCodeIsValid = null;
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_15__repositories_CompaniesRepository__["a" /* default */].getCode(_this7.$v.form.companyCode.$model).then(function (response) {
                  code = response.data;
                  _this7.codeInfo = code;
                  var clientNumberInfoDialogMsg = _this7.$te('signupOH.info.reservationNumber.' + _this7.$v.form.companyCode.$model);
                  if (clientNumberInfoDialogMsg) {
                    _this7.$store.dispatch('showSharedDialog', { content: _this7.$t('signupOH.info.reservationNumber.' + _this7.$v.form.companyCode.$model) });
                  }
                });

              case 6:
                if (code && !_this7.in360) {
                  _this7.visibleModalBusiness = true;
                }
                _this7.companyCodeIsValid = !!code;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    resetForm: function resetForm() {
      this.form.state.submitted = false;
      this.form.state.waiting = false;
      this.form.state.unauthorized = false;
      this.form.state.errors = false;
    },
    resetEmployeeNumberValidation: function resetEmployeeNumberValidation() {
      this.employeeNumberIsValid = true;
    }
  },
  computed: {
    emailValidation: function emailValidation() {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted);
    },
    emailMatches: function emailMatches() {
      return this.form.state.submitted ? this.form.email === this.form.emailConfirmation : null;
    },

    passwordValidation: function passwordValidation() {
      return this.$validators.validate(this.form.password, ['required', 'password'], this.form.state.submitted);
    },
    requiredValidation: function requiredValidation() {
      var _this8 = this;

      return function (prop) {
        return _this8.$validators.validate(prop, ['required'], _this8.form.state.submitted);
      };
    },
    nifIsValid: function nifIsValid() {
      return this.$validators.validate(this.form.nif, ['required'], this.form.state.submitted);
    },
    phoneNumberIsValid: function phoneNumberIsValid() {
      return this.$validators.validate(this.form.phoneNumber, ['required', 'phone'], this.form.state.submitted);
    },
    companyCodePlaceholder: function companyCodePlaceholder() {
      switch (SUBDOMAIN) {
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["e" /* BARCELO_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["j" /* IBEROSTAR_SUBDOMAIN */]:
          return this.$t('signupOH.reservation-number-or-code');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["r" /* WAMOS_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["d" /* ASSEGUR_SUBDOMAIN */]:
          return this.$t('signupOH.certificate-number-or-code');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["l" /* NAUTALIA_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["f" /* CARREFOUR_SUBDOMAIN */]:
          return this.$t('signupOH.generic-code');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["k" /* MSM_SUBDOMAIN */]:
          return this.$t('signupOH.code-provided-by-msm');
        default:
          return this.$t('signupOH.code-provided-by-company-or-entity');
      }
    },
    reservationNumberPlaceholder: function reservationNumberPlaceholder() {
      switch (SUBDOMAIN) {
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["e" /* BARCELO_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["j" /* IBEROSTAR_SUBDOMAIN */]:
          return this.$t('signupOH.reservation-number');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["r" /* WAMOS_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["d" /* ASSEGUR_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["l" /* NAUTALIA_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["f" /* CARREFOUR_SUBDOMAIN */]:
          return this.$t('signupOH.certificate-number');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["k" /* MSM_SUBDOMAIN */]:
          return this.$t('signupOH.client-number');
        default:
          return this.$t('signupOH.client-number');
      }
    },
    reservationNumberErrorMsg: function reservationNumberErrorMsg() {
      switch (SUBDOMAIN) {
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["e" /* BARCELO_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["j" /* IBEROSTAR_SUBDOMAIN */]:
          return this.$t('signupOH.errors.reservation-number');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["r" /* WAMOS_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["d" /* ASSEGUR_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["l" /* NAUTALIA_SUBDOMAIN */]:
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["f" /* CARREFOUR_SUBDOMAIN */]:
          return this.$t('signupOH.errors.certificate-number');
        case __WEBPACK_IMPORTED_MODULE_17__constants_subdomains__["k" /* MSM_SUBDOMAIN */]:
          return this.$t('signupOH.errors.client-number');
        default:
          return this.$t('signupOH.errors.client-number');
      }
    },
    requiredOnlyInTravelValidation: function requiredOnlyInTravelValidation() {
      var _this9 = this;

      return function (prop) {
        return _this9.isTravelCompany ? _this9.$validators.validate(prop, ['required'], _this9.form.state.submitted) : true;
      };
    },
    requiredOnlyInGenericCodesValidation: function requiredOnlyInGenericCodesValidation() {
      var _this10 = this;

      return function (prop) {
        return _this10.codeInfo.generic ? _this10.$validators.validate(prop, ['required'], _this10.form.state.submitted) : true;
      };
    },
    getCompanyCodeInputState: function getCompanyCodeInputState() {
      return !this.form.state.submitted ? this.companyCodeIsValid : this.requiredValidation(this.form.companyCode) && this.companyCodeIsValid;
    },
    getTermsFormState: function getTermsFormState() {
      return !this.form.state.submitted ? this.termsAccepted : this.termsAccepted === true;
    },
    isTravelCompany: function isTravelCompany() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__constants_companiesLandingNames__["a" /* GET_TRAVEL_COMPANIES */])().includes(SUBDOMAIN);
    },
    employeeGroupFieldIsVisible: function employeeGroupFieldIsVisible() {
      return this.codeInfo.employeeGroup && this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(function (group) {
        return !group.createdByPatient;
      });
    },
    employeeGroupFreeFieldIsVisible: function employeeGroupFreeFieldIsVisible() {
      return this.codeInfo.employeeGroup && this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(function (group) {
        return group.createdByPatient;
      });
    },
    employeeLocationFieldIsVisible: function employeeLocationFieldIsVisible() {
      return this.codeInfo.employeeGroup;
    },
    employeeNumberFieldIsVisible: function employeeNumberFieldIsVisible() {
      return this.codeInfo.employeeNumberRequired && this.ivecoAndExtensionEmailForEmployeeNumberInputDisplay();
    },
    codeIsGeneric: function codeIsGeneric() {
      return this.codeInfo.generic;
    },
    in360: function in360() {
      return Object(__WEBPACK_IMPORTED_MODULE_20__constants_platformNames__["k" /* inOpensalud360 */])();
    },
    employeeNumberState: function employeeNumberState() {
      if (this.employeeNumberIsValid === false) {
        return false;
      }
      if (this.$v.form.employeeNumber.$dirty && this.$v.form.employeeNumber.$invalid) {
        return false;
      }
      if (this.$v.form.employeeNumber.$dirty && !this.$v.form.employeeNumber.$invalid) {
        return true;
      }
      return null;
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_19__repositories_LanguageRepository__["a" /* default */].getLanguages().then(function (response) {
                _this11.form.formSelectLang.options = response.data;
              });
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_18__repositories_GeographyRepository__["a" /* default */].getCountries().then(function (response) {
                _this11.form.selectedCountry.options = response.data;
                _this11.form.selectPrefix.options = response.data;
                // console.log(this.$i18nHelpers.getNormalizedLocale())
                // console.log(this.prefixCountry)
                _this11.form.countryId = Object(__WEBPACK_IMPORTED_MODULE_23__helpers_global_helpers__["e" /* getDefaultCountryId */])();
                _this11.form.prefixCountry = Object(__WEBPACK_IMPORTED_MODULE_23__helpers_global_helpers__["f" /* getDefaultPhonePrefix */])();
                /*       const selectedCountry = this.form.selectedCountry.options.find(country => !this.inMx ? country.idCountry === SPAIN_COUNTRY_ID : country.idCountry === MX_COUNTRY_ID) */
                /* this.form.countryId = selectedCountry.idCountry */
                __WEBPACK_IMPORTED_MODULE_18__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(_this11.form.countryId).then(function (response) {
                  _this11.form.selectProvince.options = response.data;
                });
              });

            case 3:

              // Check for available api client token and company code in peristed $store
              if (_this11.$store.getters['session/referralActiveByApiClient']) {
                _this11.form.companyCode = _this11.$store.state.session.user.companyCode.code;
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this11);
    }))();
  }
});

/***/ }),

/***/ 2961:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("47772cba", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7820e2fe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PatientSignupForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7820e2fe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PatientSignupForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2962:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-7820e2fe]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-7820e2fe],.slide-down-leave-active[data-v-7820e2fe]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-7820e2fe],.slide-down-leave-to[data-v-7820e2fe]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-7820e2fe],.slide-fade-left-leave-active[data-v-7820e2fe]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-7820e2fe],.slide-fade-left-leave-to[data-v-7820e2fe]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-7820e2fe]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-7820e2fe],.fade-leave-to[data-v-7820e2fe]{opacity:0\n}\nspan .vs__selected[data-v-7820e2fe]{margin-left:1%;font-size:0.8rem\n}\n.v-select[data-v-7820e2fe]{margin-top:0px !important;margin-bottom:0px !important\n}\n.vs__selected[data-v-7820e2fe]{margin-left:1rem !important;padding:0 0.8em !important\n}\ndiv .v-select .vs--unsearchable[data-v-7820e2fe]{margin:0px !important\n}\n.vs__selected[data-v-7820e2fe],.vs__search[data-v-7820e2fe],.vs__search[data-v-7820e2fe]:focus{margin-left:1rem !important\n}\n.v-select .vs--single .vs--unsearchable[data-v-7820e2fe]{margin:0px !important\n}\ndiv .mt-3[data-v-7820e2fe],button[data-v-7820e2fe],p[data-v-7820e2fe],fieldset[data-v-7820e2fe],.v-select[data-v-7820e2fe],.custom-checkbox[data-v-7820e2fe],.my-3[data-v-7820e2fe]{margin-top:0rem !important\n}\n#lang[data-v-7820e2fe]{margin-top:0rem !important;margin-bottom:0rem !important\n}\n#prefix[data-v-7820e2fe]{margin-top:0rem !important;margin-bottom:0rem !important\n}\n#country[data-v-7820e2fe]{margin-top:0rem !important;margin-bottom:0rem !important\n}\n#province[data-v-7820e2fe]{margin-top:0rem !important;margin-bottom:0rem !important\n}\n#genderForm[data-v-7820e2fe]{text-align:left !important\n}\n.genderText[data-v-7820e2fe]{font-weight:400;line-height:1.6;color:#495057;padding:0rem 2.2rem\n}\n.row[data-v-7820e2fe]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n@media (max-width: 1024px){\n.Body1_OH-sm[data-v-7820e2fe]{display:block !important;margin-right:0px !important;margin-left:0px !important\n}\n}\n.headerMenu[data-v-7820e2fe]{margin:22px 133px 0px 4%\n}\ndiv .Body3_rightCol[data-v-7820e2fe]{padding-right:0px !important;padding-left:0px !important\n}\n.Body2_OH[data-v-7820e2fe]{margin:5% 0% 0% 12% !important\n}\n.Body3_div[data-v-7820e2fe]{display:block;padding:8% 0px 8% 10% !important;background-color:#1D1D1E;opacity:87%;margin:0px 0% 0px 0px !important\n}\n.os-card[data-v-7820e2fe]{border-radius:23px !important;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);margin-bottom:2rem\n}\n@media only screen and (min-width: 1024px){\n.os-card[data-v-7820e2fe]{padding:3rem 6rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.os-card[data-v-7820e2fe]{padding:3rem 6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.os-card[data-v-7820e2fe]{padding:3rem 6rem\n}\n}\n@media only screen and (max-width: 575px){\n.os-card[data-v-7820e2fe]{padding:3rem 1rem\n}\n.os-card h3[data-v-7820e2fe]{font-size:1.3rem\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "os-card" },
    [
      _c("h3", { staticClass: "text-center mb-5" }, [
        _vm._v(_vm._s(_vm.$helpers.getMetaTitleText(_vm.$route)))
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: { variant: "danger" },
          model: {
            value: _vm.form.state.errors,
            callback: function($$v) {
              _vm.$set(_vm.form.state, "errors", $$v)
            },
            expression: "form.state.errors"
          }
        },
        [_vm._v(_vm._s(_vm.$t("signupOH.errors.general-code")))]
      ),
      _vm._v(" "),
      _vm.form.state.submitted && _vm.form.state.unauthorized
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.submitError) } })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.userRegistered
        ? _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.signUpCheck.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { sm: "12", xl: "6" } },
                    [
                      !_vm.inOpenlegal() &&
                      !_vm.$store.getters["session/referralActiveByApiClient"]
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.registerCodeEnt"
                                  ),
                                  state: _vm.companyCodeIsValid
                                },
                                on: {
                                  blur: _vm.checkCompanyCode,
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.companyCode.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.form.companyCode,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.form.companyCode.$model"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.inOpensalud360() &&
                              (!_vm.$v.form.companyCode.$model ||
                                _vm.companyCodeIsValid)
                                ? _c("b-form-text", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "signupOH.justIndicatedByBusiness"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state:
                                          !_vm.inOpensalud360() ||
                                          _vm.companyCodeIsValid == true
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signupOH.errors.enterCode")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.codeInfo.generic
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.reservationNumberPlaceholder,
                                          state: _vm.validateState(
                                            "reservationNumber"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.reservationNumber
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.reservationNumber,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.reservationNumber.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(_vm.reservationNumberErrorMsg)
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal() && _vm.inOpensalud360()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.employeeGroupFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("base-select", {
                                        attrs: {
                                          options: _vm.codeInfo.employeeGroup,
                                          valueProp: "id",
                                          label: "groupName",
                                          placeholder: _vm.$t(
                                            "signupOH.center-or-business-unit"
                                          ),
                                          state: _vm.validateState(
                                            "employeeGroup"
                                          ),
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.center-or-business-unit"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeGroup.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeGroup,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeGroup.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.employeeGroupFreeFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "signupOH.employeeLocation"
                                          ),
                                          state: _vm.validateState(
                                            "employeeLocation"
                                          ),
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.employeeLocation"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeLocation.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeLocation,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeLocation.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal() && _vm.inOpensalud360()
                        ? _c(
                            "transition",
                            { attrs: { name: "fade" } },
                            [
                              _vm.employeeNumberFieldIsVisible
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "signupOH.internal-code"
                                          ),
                                          state: _vm.employeeNumberState,
                                          errorMsg: _vm.$t(
                                            "signupOH.errors.required-employee-number"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.resetEmployeeNumberValidation()
                                            _vm.resetForm()
                                          },
                                          blur: function($event) {
                                            return _vm.$v.form.employeeNumber.$touch()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.employeeNumber.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.employeeNumber,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.employeeNumber.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.employeeNumberIsValid === false
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.employee-number"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$v.form.employeeNumber.$dirty &&
                                      _vm.$v.form.employeeNumber.$invalid &&
                                      _vm.employeeNumberIsValid !== false
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.required-employee-number"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inOpenlegal()
                        ? _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.isTravelCompany
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "12", xl: "12" } },
                                        [
                                          _c("base-datepicker", {
                                            attrs: {
                                              "value-as-date": "",
                                              state: _vm.validateState(
                                                "reservationFromDate"
                                              ),
                                              placeholder: _vm.$t(
                                                "signupOH.checkin-date"
                                              ),
                                              validator:
                                                _vm.$v.form.reservationFromDate
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.reservationFromDate
                                                  .$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form
                                                    .reservationFromDate,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.reservationFromDate.$model"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "12", xl: "12" } },
                                        [
                                          _c("base-datepicker", {
                                            attrs: {
                                              "value-as-date": "",
                                              state: _vm.validateState(
                                                "reservationToDate"
                                              ),
                                              placeholder: _vm.$t(
                                                "signupOH.checkout-date"
                                              ),
                                              validator:
                                                _vm.$v.form.reservationToDate,
                                              parentValidators: _vm.$v.form
                                            },
                                            model: {
                                              value:
                                                _vm.$v.form.reservationToDate
                                                  .$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.$v.form.reservationToDate,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.form.reservationToDate.$model"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("signupOH.registerName"),
                                  state: _vm.validateState("name")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.name.$model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                                  },
                                  expression: "$v.form.name.$model"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  _vm._s(_vm.$t("signupOH.errors.enterName"))
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.companyCode && _vm.codeInfo.codeType === 2
                        ? _c(
                            "b-form-group",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.registerNameCenterResidence"
                                  ),
                                  state: _vm.validateState("name")
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.resetForm()
                                  }
                                },
                                model: {
                                  value: _vm.$v.form.name.$model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                                  },
                                  expression: "$v.form.name.$model"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  _vm._s(_vm.$t("signupOH.errors.enterName"))
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-md-1 pr-0",
                                  attrs: { sm: "12", xl: "6" }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerSurname1"
                                          ),
                                          state: _vm.validateState(
                                            "firstSurname"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.firstSurname.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.firstSurname,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.firstSurname.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "signupOH.errors.enterSurname1"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "pl-md-1 pl-0",
                                  attrs: { sm: "12", xl: "6" }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerSurname2"
                                          ),
                                          state: _vm.validateState(
                                            "secondSurname"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.$v.form.secondSurname.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.secondSurname,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.form.secondSurname.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "signupOH.errors.enterSurname2"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$uiHelpers.isMobile ? _c("br") : _vm._e(),
                      _vm._v(" "),
                      _c("b-form-group", [
                        !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                          ? _c(
                              "div",
                              { staticClass: "inline-input text-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-uppercase pr-4 d-inline-block genderText"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("signupOH.genderSex")))]
                                ),
                                _vm._v(" "),
                                _c("radio-button-gender", {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    state: _vm.validateState("gender"),
                                    errorMsg: _vm.$t("signupOH.errors.enterSex")
                                  },
                                  model: {
                                    value: _vm.$v.form.gender.$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.form.gender,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression: "$v.form.gender.$model"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !_vm.form.companyCode || _vm.codeInfo.codeType != 2
                        ? _c(
                            "div",
                            { staticClass: "inline-input text-center" },
                            [
                              _c("base-birthdate-input", {
                                model: {
                                  value: _vm.form.birthDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "birthDate", $$v)
                                  },
                                  expression: "form.birthDate"
                                }
                              }),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.validateState("birthDate")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signupOH.errors.enterBirthdate"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("base-select", {
                            attrs: {
                              id: "country",
                              searchable: true,
                              placeholder: _vm.$t("signupOH.country"),
                              options: _vm.form.selectedCountry.options,
                              state: _vm.validateState("countryId"),
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              valueProp: "idCountry",
                              errorMsg: _vm.$t("signupOH.errors.enterCountry"),
                              clearable: false
                            },
                            on: { change: _vm.reCallProvince },
                            model: {
                              value: _vm.$v.form.countryId.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.countryId, "$model", $$v)
                              },
                              expression: "$v.form.countryId.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("base-select", {
                            attrs: {
                              id: "province",
                              searchable: true,
                              placeholder: _vm.$t(
                                "signupOH.registerYourProvince"
                              ),
                              state: _vm.validateState("stateId"),
                              options: _vm.form.selectProvince.options,
                              label: _vm.$i18nHelpers.normalizeProp("name"),
                              valueProp: "id"
                            },
                            model: {
                              value: _vm.$v.form.stateId.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.stateId, "$model", $$v)
                              },
                              expression: "$v.form.stateId.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-3", attrs: { sm: "12", xl: "6" } },
                    [
                      _vm.codeInfo.codeType != 2
                        ? _c(
                            "div",
                            [
                              _vm.form.countryId === 28
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.registerNIF"
                                          ),
                                          state: _vm.validateState("nif")
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state:
                                                  _vm.form.nif != null
                                                    ? _vm.validateNIF(
                                                        _vm.form.nif
                                                      )
                                                    : false
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.countryId === 42
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.enterCURP"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.form.nif != null
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterCURP"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.countryId !== 42 &&
                              _vm.form.countryId !== 28
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "signupOH.enterId"
                                          )
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.resetForm()
                                          }
                                        },
                                        model: {
                                          value: _vm.$v.form.nif.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.form.nif,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.form.nif.$model"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.form.trySubmit && _vm.dniregistered
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.dniregistered != true
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.duplicatedNIF"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.trySubmit &&
                                      _vm.dniregistered != true
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            {
                                              attrs: {
                                                state: _vm.form.nif != null
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "signupOH.errors.enterID"
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("signupOH.registerEmail"),
                              state: _vm.validateState("email")
                            },
                            on: {
                              blur:
                                _vm.ivecoAndExtensionEmailForEmployeeNumberInputDisplay,
                              input: function($event) {
                                return _vm.resetForm()
                              }
                            },
                            model: {
                              value: _vm.$v.form.email.$model,
                              callback: function($$v) {
                                _vm.$set(_vm.$v.form.email, "$model", $$v)
                              },
                              expression: "$v.form.email.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("signupOH.errors.enterEmail")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("signupOH.confirmEmail"),
                              state: _vm.validateState("emailConfirmation")
                            },
                            on: {
                              input: function($event) {
                                return _vm.resetForm()
                              }
                            },
                            model: {
                              value: _vm.$v.form.emailConfirmation.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.form.emailConfirmation,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.emailConfirmation.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("signupOH.errors.enterConfirmEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "pr-md-2 pr-0",
                              attrs: { sm: "12", xl: "5" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("base-select", {
                                    attrs: {
                                      id: "prefix",
                                      searchable: true,
                                      placeholder: _vm.$t(
                                        "signupOH.registerPhonePrefix"
                                      ),
                                      options: _vm.form.selectPrefix.options,
                                      state: _vm.validateState("prefixCountry"),
                                      label: _vm.$i18nHelpers.normalizeProp(
                                        "prefixAndCountry"
                                      ),
                                      valueProp: "phonePrefix"
                                    },
                                    model: {
                                      value: _vm.$v.form.prefixCountry.$model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$v.form.prefixCountry,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.form.prefixCountry.$model"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "12", xl: "7" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: _vm.$t(
                                        "signupOH.registerPhoneNumber"
                                      ),
                                      state: _vm.validateState("phoneNumber")
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.resetForm()
                                      }
                                    },
                                    model: {
                                      value: _vm.$v.form.phoneNumber.$model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$v.form.phoneNumber,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.form.phoneNumber.$model"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.form.trySubmit
                                    ? _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state: _vm.form.phoneNumber != null
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "signupOH.errors.enterPhoneNumber"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("v-select", {
                            attrs: {
                              id: "lang",
                              multiple: "",
                              getOptionLabel: function(option) {
                                return _vm.$i18nHelpers.normalizeProp(
                                  "name"
                                ) === "name.es"
                                  ? option.name.es
                                  : option.name.en
                              },
                              placeholder: _vm.$t("signupOH.selectLanguageTxt"),
                              options: this.form.formSelectLang.options
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _vm._t("option", null, { option: option })
                                    ]
                                  }
                                },
                                {
                                  key: "no-options",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("signupOH.no-options")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "open-indicator",
                                  fn: function(ref) {
                                    var attributes = ref.attributes
                                    return [
                                      _c(
                                        "span",
                                        _vm._b({}, "span", attributes, false),
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "12",
                                                height: "6",
                                                viewBox: "0 0 12 6"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id: "Path_4_Copy",
                                                  "data-name": "Path 4 Copy",
                                                  d: "M0,0,6,6,0,12Z",
                                                  transform:
                                                    "translate(12) rotate(90)",
                                                  fill: "#8a8a8a"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.$v.form.selectedLangs.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.form.selectedLangs,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.form.selectedLangs.$model"
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("selectedLangs")
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("signupOH.errors.enterLang")
                                      )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.inOpensalud360()
                        ? _c(
                            "b-form-group",
                            [
                              _c("base-select", {
                                attrs: {
                                  id: "discovery",
                                  state: _vm.validateState("discoveryCheck"),
                                  searchable: true,
                                  label: "text",
                                  placeholder: _vm.$t(
                                    "signupOH.selectDiscovery"
                                  ),
                                  options: this.form.selectDiscovery.options
                                },
                                model: {
                                  value: _vm.form.discoveryCheck,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "discoveryCheck", $$v)
                                  },
                                  expression: "form.discoveryCheck"
                                }
                              }),
                              _vm._v(" "),
                              _vm.form.trySubmit
                                ? _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state: _vm.form.discoveryCheck != null
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signupOH.errors.enterDiscoveryType"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.form.termsAccepted,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "termsAccepted", $$v)
                            },
                            expression: "form.termsAccepted"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("signupOH.accept-terms-patient")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("termsAccepted")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("signupOH.errors.termsAccepted")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.form.privacyAccepted,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "privacyAccepted", $$v)
                            },
                            expression: "form.privacyAccepted"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("signupOH.accept-privacy-patient")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.validateState("privacyAccepted")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("signupOH.errors.privacyAccepted")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          staticStyle: {
                            "align-items": "center",
                            "justify-content": "center",
                            "padding-bottom": "1rem",
                            "text-align": "center"
                          }
                        },
                        [
                          _c("VueRecaptcha", {
                            attrs: {
                              sitekey: _vm.siteKey,
                              "load-recaptcha-script": true
                            },
                            on: {
                              verify: _vm.handleSuccess,
                              error: _vm.handleError,
                              expired: _vm.handleError
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.trySubmit
                            ? _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: { state: _vm.validateState("captcha") }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("signupOH.errors.captcha"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "button", variant: "primary" },
                      on: { click: _vm.signUpCheck }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("signupOH.signup-submit")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("signUp.already-registered")) + ", "),
                    _c("a", { attrs: { href: "/sign-in" } }, [
                      _vm._v(_vm._s(_vm.$t("sign-up-href")))
                    ]),
                    _vm._v(".")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    "title-class": "title-modal",
                    centered: "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function() {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.okBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.signUp()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n    " +
                                    _vm._s(_vm.$t("signupOH.continue")) +
                                    "\n    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.cancelBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInCancelBNP()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n     " +
                                    _vm._s(_vm.$t("signupOH.cancel")) +
                                    "\n    "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    535626102
                  ),
                  model: {
                    value: _vm.visibleModalMessageInfo,
                    callback: function($$v) {
                      _vm.visibleModalMessageInfo = $$v
                    },
                    expression: "visibleModalMessageInfo"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _vm._l(_vm.codeInfo.infoMessages, function(
                        translation,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "1rem" }
                          },
                          [
                            _c(
                              "h6",
                              {
                                staticStyle: {
                                  "margin-bottom": "0rem !important"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18nHelpers.normalize(translation)
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                        _c("h6", [_vm._v(_vm._s(_vm.$t("bnpMSG2")))])
                      ])
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    "title-class": "title-modal",
                    centered: "",
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function() {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.okBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInOkFnBusiness()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n    " +
                                    _vm._s(_vm.$t("signupOH.continue")) +
                                    "      \n    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: _vm.cancelBtnVariant },
                                on: {
                                  click: function($event) {
                                    return _vm.builtInCancelFnBusiness()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n     " +
                                    _vm._s(_vm.$t("signupOH.cancel")) +
                                    "      \n    "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    31656633
                  ),
                  model: {
                    value: _vm.visibleModalBusiness,
                    callback: function($$v) {
                      _vm.visibleModalBusiness = $$v
                    },
                    expression: "visibleModalBusiness"
                  }
                },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                      _c(
                        "h6",
                        { staticStyle: { "margin-bottom": "0rem !important" } },
                        [_vm._v(_vm._s(_vm.$t("signupOH.modalBusiness")) + " ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "1rem" } }, [
                      _c("h6", [
                        _vm._v(_vm._s(_vm.$t("signupOH.modalBusiness2")))
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userRegistered
        ? _c("div", { attrs: { id: "account-confirmation" } }, [
            _c("p", {
              staticClass: "text-left",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("signupOH.account-confirmation", {
                    email: _vm.$v.form.email.$model
                  })
                )
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7820e2fe", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/142.0a790eef06a6cbafb829.js